<template>
  <!-- ... -->


  <!-- Dialog de Loading -->
  <v-dialog v-model="loadingDialog" persistent max-width="450px">
    <v-card class="d-flex flex-column align-center justify-center pa-0"
      style="background-color: transparent !important">
      <v-card-text class="text-center pt-0 ">

        <div class="text-h6 font-weight-bold mt-5">{{ mensagemDialog }}</div>

        <div class="d-flex justify-center mt-4">
          <v-progress-linear indeterminate color="primary" class="mb-5" style="width: 100%"></v-progress-linear>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-container v-if="!loadingDialog" class="overflow-y-auto"
    style="max-height: calc(100vh - 100px); padding-bottom: 24px;">

    <!-- Card de Dados do Pedido -->
    <v-card class="mb-6">
      <v-card-title class="bg-light-blue-lighten-1 white--text d-flex align-center">

        <v-icon color="white" class="mr-2">mdi-file-document</v-icon>
        Dados do Pedido

        <v-spacer></v-spacer>




        <v-btn small color="white" :disabled="1 == 2" variant="outlined" @click="submitForm" class="mr-4">
          <v-icon left>mdi-plus</v-icon>
          Salvar Pedido
        </v-btn>

        <!-- quero criar chips do se esta alteando ou incluindo vamos colocar um backgroud no chip preto -->
        <v-chip v-if="isEdit" class="mr-2" color="white" label text-color="white"
          style="background-color: black !important;">
          Alterando
        </v-chip>
        <v-chip v-else class="mr-2" color="white" label text-color="white" style="background-color: black !important">
          Incluindo
        </v-chip>

        <v-chip class="ml-10" color="white" label text-color="white" style="background-color: black !important">
          Status do Pedido: {{ pedido.pedido_status }}
        </v-chip>


        <v-btn small color="white" variant="outlined" class="ml-5" @click="voltarMenu">
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <v-row dense>
          <v-col cols="12" sm="6" md="2">
            <v-text-field :readonly="isEdit" v-model="pedido.id_pedido" label="ID Pedido" variant="outlined"
              density="comfortable"></v-text-field>
          </v-col>
          <!-- criar um botao pra pesquisar o pedido -->
          <v-col cols="12" sm="6" md="2">
            <v-btn :disabled="loadingDialog || !pedido.id_pedido" small color="primary"
              @click="getPedidoSapePorId(pedido.id_pedido)">
              <v-icon left>mdi-magnify</v-icon>
              Pesquisar SAP
            </v-btn>
          </v-col>
          <v-col cols="8">

            <v-autocomplete v-model="pedido.id_cliente" :items="clientesDisponiveis" label="Cliente" item-title="nome"
              item-value="id" clearable :item-text="(item) => `${item.nome} - ${item.id}`" variant="outlined"
              density="comfortable"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-text-field v-model="pedido.data_cadastro" label="Data Cadastro" type="date" variant="outlined"
              density="comfortable"></v-text-field>
          </v-col>

          <v-col cols="12" sm="4" md="2">
            <v-text-field v-model="pedido.previsao_entrega" label="Previsão Entrega" type="date" variant="outlined"
              density="comfortable"></v-text-field>
          </v-col>


          <v-col cols="12" sm="4" md="2">
            <v-text-field v-model="pedido.data_inicio" label="Data Início" type="date" variant="outlined"
              density="comfortable"></v-text-field>
          </v-col>

          <!-- Card para exibir produtos do SAPE -->
          <v-col cols="12">
            <v-card v-if="dadosPedidoSape?.pedido" class="mt-4 mb-6">
              <v-card-title class="bg-light-blue-lighten-1 white--text">
                <v-icon color="white" class="mr-2">mdi-package-variant</v-icon>
                Produtos do Pedido SAP

                <v-chip color="white" label text-color="white" style="background-color: black !important;">
                  Quantidades de Modelos: {{ dadosPedidoSape?.pedido?.total_produtos || 0 }}
                </v-chip>

                <v-chip class="ml-5" color="white" label text-color="white" style="background-color: black !important;">
                  Total de Peças: {{ dadosPedidoSape?.pedido?.total_quantidade || 0 }}
                </v-chip>


              </v-card-title>
              <!-- <v-card-subtitle>
                <v-chip class="mr-2 mt-2" color="white" label text-color="white"
                  style="background-color: black !important;">
                  <strong>Total de Produtos: </strong> {{ dadosPedidoSape?.pedido?.total_produtos || 0 }}<br>

                </v-chip>
                <v-chip class="mr-2 mt-2" color="white" label text-color="white"
                  style="background-color: black !important">

                  <strong>Total de Quantidade:</strong> {{ dadosPedidoSape?.pedido?.total_quantidade || 0 }}
                </v-chip>

              </v-card-subtitle> -->

              <v-card-text>
                <v-table class="mb-5 mt-5">
                  <thead class="mt-3" style="background-color: lightgray !important; font-weight: bold !important;">
                    <tr>
                      <th>Descrição</th>
                      <th>Código</th>
                      <th>Pai</th>
                      <th>Ref</th>
                      <th>Quantidade</th>
                      <th>Ord. Prod.</th>
                      <th>Base</th>
                      <th>Atual</th>
                      <th>Diferenças</th>
                      <th>Relatório</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(produto, index) in dadosPedidoSape.produtos" :key="index" class="hover">

                      <td style="font-weight: bold;">{{ produto.descricao_produto }}</td>


                      <td>{{ produto.id_produto }}</td>
                      <td>{{ produto.id_pai }}</td>
                      <td>{{ produto.referencia }}</td>
                      <td>{{ produto.quantidade }}</td>
                      <td>
                        <v-chip size="large" class="mr-1"
                          style="background-color: lightskyblue !important; font-weight: bold !important;">
                          OP: {{ produto.ordem_producao?.numero }}
                        </v-chip>
                      </td>
                      <!-- Base de composicao -->
                      <td @click="mostrarFichaComposicao(produto)" style="cursor: pointer">
                        <v-icon>mdi-file-document-outline</v-icon>
                      </td>
                      <!-- Composicao feita espefica para ordem de producao -->
                      <td @click="mostrarFichaComposicaoPedidoAtual(produto)" style="cursor: pointer">
                        <v-icon>mdi-file-document-outline</v-icon>
                      </td>
                      <td :disabled="!produto?.diferenca?.length > 0"
                        @click="calcularDiferenca(produto, produto.ordem_producao.numero)" style="cursor: pointer">
                        <v-icon color="red">mdi-file-compare</v-icon>
                      </td>
                      <td @click="gerarPdfFichaComposicao(produto)" style="cursor: pointer">
                        <v-icon>mdi-file-pdf-box</v-icon>
                      </td>
                      <td @click="gerarPdfFichaComposicaoEduardo()" style="cursor: pointer">
                        Eduardo <v-icon>mdi-file-pdf-box</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </v-card-text>
            </v-card>
          </v-col>






          <!-- Dialog para Ficha de Composição -->
          <v-dialog v-model="fichaComposicaoDialog.show" auto-width auto-height fullscreen>
            <v-card>
              <v-card-title class="bg-light-blue-lighten-1 white--text">
                <v-icon color="white" class="mr-2">mdi-file-document-outline</v-icon>
                Ficha de Composição
              </v-card-title>
              <v-card-text class="pt-4">
                <div v-if="fichaComposicaoDialog.produto">
                  <h3>{{ fichaComposicaoDialog.produto.descricao_produto }}</h3>
                  <p><strong>Código:</strong> {{ fichaComposicaoDialog.produto.id_produto }}</p>
                  <p><strong>Tamanho:</strong> {{ fichaComposicaoDialog.produto.tamanho }}</p>

                  <v-divider class="my-4"></v-divider>

                  <div v-if="fichaComposicaoDialog.produto.ficha_composicao">
                    <h4>Componentes</h4>
                    <v-table>
                      <thead class="table-header">
                        <tr>
                          <th>Código</th>
                          <th>Referência</th>
                          <th>Descrição</th>
                          <th>Unidade</th>
                          <th>Quantidade</th>
                          <th>Est. Físico</th>
                          <th>Comprom</th>
                          <th>Em Compra</th>
                          <th>Disponível</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in fichaComposicaoDialog.produto.ficha_composicao"
                          :key="item.codigo_componente"
                          :class="index % 2 === 0 ? 'bg-grey-lighten-4' : 'bg-blue-lighten-5'">
                          <td>{{ item.codigo_componente }}</td>
                          <td>{{ item.referencia }}</td>
                          <td>{{ item.nome_componente }}</td>
                          <td>{{ item.unidade_medida }}</td>
                          <td>{{ item.quantidade }}</td>
                          <td>{{ item.estoque_fisico }}</td>
                          <td>{{ item.comprometido }}</td>
                          <td>{{ item.em_compra }}</td>
                          <td>{{ item.disponivel }}</td>
                        </tr>
                      </tbody>
                    </v-table>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!-- Dialog para Ficha de Composição Pedido Atual -->
          <v-dialog v-model="fichaComposicaoDialogPedidoAtual.show" auto-width auto-height fullscreen>
            <v-card>
              <v-card-title class="bg-light-blue-lighten-1 white--text">
                <v-icon color="white" class="mr-2">mdi-file-document-outline</v-icon>
                Ficha de Composição do Pedido Atual
              </v-card-title>
              <v-card-text class="pt-4">
                <div v-if="fichaComposicaoDialogPedidoAtual.produto">
                  <h3>{{ fichaComposicaoDialogPedidoAtual.produto.descricao_produto }}</h3>
                  <p><strong>Código:</strong> {{ fichaComposicaoDialogPedidoAtual.produto.id_produto }}</p>
                  <p><strong>Tamanho:</strong> {{ fichaComposicaoDialogPedidoAtual.produto.tamanho }}</p>
                  <p><strong>Ordem de Produção:</strong> {{
                    fichaComposicaoDialogPedidoAtual.produto.ordem_producao.numero }}</p>

                  <div v-if="fichaComposicaoDialogPedidoAtual.produto.ficha_composicao_pedido_atual">
                    <v-table>
                      <thead class="table-header">
                        <tr>
                          <th>Ordem</th>
                          <th>Código</th>
                          <th>Referência</th>
                          <th>Descrição</th>
                          <th>Quantidade</th>
                          <th>Unidade</th>
                          <th>Est. Físico</th>
                          <th>Comprom</th>
                          <th>Em Compra</th>
                          <th>Disponível</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in fichaComposicaoDialogPedidoAtual.produto.ficha_composicao_pedido_atual.filter(i => String(i.DocEntry) === String(fichaComposicaoDialogPedidoAtual.produto.ordem_producao.numero))"
                          :key="item.ItemCode" :class="index % 2 === 0 ? 'bg-grey-lighten-4' : 'bg-blue-lighten-5'">
                          <td>{{ item.DocEntry }}</td>
                          <td>{{ item.ItemCode }}</td>
                          <td>{{ item.Referencia }}</td>
                          <td>{{ item.Descricao }}</td>
                          <td>{{ item.QtdePlanej }}</td>
                          <td>{{ item.Unidade }}</td>
                          <td>{{ item.EstFis }}</td>
                          <td>{{ item.Comprometido }}</td>
                          <td>{{ item.EmCompra }}</td>
                          <td>{{ item.DisponPrev }}</td>
                        </tr>
                      </tbody>
                    </v-table>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!-- Dialog para Diferença entre Fichas -->
          <v-dialog v-model="fichaComposicaoDiferencaDialog.show" auto-width auto-height fullscreen>
            <v-card>
              <v-card-title class="bg-light-blue-lighten-1 white--text">
                <v-icon color="white" class="mr-2">mdi-file-compare</v-icon>
                Diferença entre Fichas
              </v-card-title>
              <v-card-text class="pt-4">
                <div v-if="diferenca.length > 0">
                  <v-table>
                    <thead class="table-header">
                      <tr>
                        <th>Status</th>
                        <th>Código</th>
                        <th>Referência</th>
                        <th>Descrição</th>
                        <th>Unidade</th>
                        <th>Quantidade (Composição)</th>
                        <th>Quantidade (Pedido Atual)</th>
                        <th>Diferença</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in diferenca" :key="item.codigo"
                        :class="index % 2 === 0 ? 'bg-grey-lighten-4' : 'bg-blue-lighten-5'">
                        <td>{{ item.status }}</td>
                        <td>{{ item.codigo }}</td>
                        <td>{{ item.referencia }}</td>
                        <td>{{ item.descricao }}</td>
                        <td>{{ item.unidade }}</td>
                        <td>{{ item.qtdeComposicao }}</td>
                        <td>{{ item.qtdePedidoAtual }}</td>
                        <td>{{ item.diferencaQuantidade }}</td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
                <div v-else>
                  <p>Não há diferenças entre as fichas de composição e o pedido atual.</p>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>



          <!-- quero criar uma for pra mostrar todos os produtos dadosPedidoSSape -->

          <!-- Novo Card com Visão Agrupada -->
          <v-col cols="12">
            <v-card v-if="dadosPedidoSape?.pedido" class="mt-4 mb-6">
              <v-card-title class="bg-light-blue-lighten-1 white--text">
                <v-icon color="white" class="mr-2">mdi-view-grid</v-icon>
                Visão Agrupada por Modelo
              </v-card-title>
              <v-card-text>
                <v-table class="mb-5 mt-5">

                  <tbody>
                    <template v-for="modelo in agruparProdutosPorModelo()" :key="modelo.id_pai">
                      <!-- Linha do modelo -->
                      <tr style="background-color: lightgray !important; font-weight: bold !important;">
                        <td>{{ modelo.id_pai }}</td>
                        <td>{{ modelo.nome_produto }}</td>
                        <td>{{ modelo.referencia }}</td>
                        <td>
                          <!-- criar um botao pra chamar um relatorio -->
                          <v-btn icon color="primary" dark @click="chamarRelatorioAgrupadoPorModelo(modelo)">
                            <v-icon>mdi-printer</v-icon>
                          </v-btn>

                          <v-btn icon color="primary" dark @click="gerarPdfFichaComposicaoEduardo()">
                            <v-icon>mdi-preview</v-icon>
                          </v-btn>
                        </td>
                        <td>


                          <v-chip color variant="outlined" size="large" class="mr-1"
                            style="background-color: lightgray !important; font-weight: bold !important;">
                            Peças {{ somarQuantidadePai(modelo.id_pai) }}
                          </v-chip>



                        </td>


                        <td>
                          <v-chip-group>
                            <v-chip v-for="(info, grade) in modelo.tamanhos" :key="grade" color variant="outlined"
                              size="large" class="mr-1"
                              style="background-color: lightgray !important; font-weight: bold !important;">
                              {{ grade }}: {{ info.quantidade }}
                            </v-chip>
                          </v-chip-group>
                        </td>
                      </tr>
                      <!-- Linha das ordens de produção -->
                      <tr>
                        <td colspan="6" class="pa-2 bg-grey-lighten-4">
                          <v-table dense>
                            <thead>
                              <tr>
                                <th>Tamanho</th>
                                <th>Número OP</th>
                                <th>Data Início</th>
                                <th>Data Vencimento</th>
                                <th>Qtd. Planejada</th>
                                <th>Qtd. Fabricada</th>
                              </tr>
                            </thead>
                  <tbody>
                    <tr v-for="ordem in modelo.ordens_producao" :key="ordem.numero + ordem.grade">
                      <td><v-chip>{{ ordem.grade }}</v-chip></td>
                      <td><v-chip color="primary" dark>{{ ordem.numero }}</v-chip></td>
                      <td>{{ ordem.data_inicio }}</td>
                      <td>{{ ordem.data_vencimento }}</td>

                      <td><v-chip color="black">{{ ordem.quantidade }}</v-chip></td>


                      <td>{{ ordem.quantidade_fabricada }}</td>
                    </tr>
                  </tbody>
                </v-table>
                </td>
                </tr>
</template>
</tbody>
</v-table>
</v-card-text>
</v-card>
</v-col>



<!--
           <v-col cols="12" sm="6" md="2">
            <v-text-field  :readonly="isEdit"  v-model="pedido.pedido_status" label="Pedido Status" variant="outlined"
              density="comfortable"></v-text-field>
          </v-col> 
          -->



</v-row>



</v-card-text>



</v-card>

<!-- Card de Modelos -->
<v-card class="mb-6">
  <v-card-title class="bg-light-blue-lighten-1 white--text d-flex align-center">


    <v-icon color="white" class="mr-2">mdi-tshirt-crew</v-icon>
    Modelos
    <v-spacer></v-spacer>
    <span v-show="pedidoModelos.length > 0" class="mr-2">Pe&ccedil;as: {{
      calcularTotalPecas.toLocaleString('pt-BR', { minimumIntegerDigits: 3, useGrouping: true }) }}</span>
    <v-spacer></v-spacer>
    <span v-show="pedidoModelos.length > 0" class="mr-2"> Modelos: {{ pedidoModelos.length.toLocaleString('pt-BR',
      { minimumIntegerDigits: 3, useGrouping: true }) }}</span>
    <v-spacer></v-spacer>

    <v-text-field v-show="pedidoModelos.length > 0" v-model="search" append-icon="mdi-magnify" label="Buscar"
      single-line hide-details dark class="mr-4" style="max-width: 300px"></v-text-field>


    <v-btn color="white" variant="outlined" @click="openModeloDialog">
      <v-icon left>mdi-plus</v-icon>
      Novo Modelo
    </v-btn>

    <v-btn v-if="dadosPedidoSape && dadosPedidoSape.produtos" color="white" variant="text" class="mr-2"
      @click="importarModelosSape">
      <v-icon left>mdi-import</v-icon>
      Importar do SAPE
    </v-btn>

  </v-card-title>

  <v-card-text class="mt-5" v-show="pedidoModelos.length > 0">
    <v-data-table :headers="headers" :items="pedidoModelos" :search="search" :options.sync="options"
      :items-per-page="options.itemsPerPage" class="elevation-1" :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Itens por página',
        pageText: '{0}-{1} de {2}'
      }">
      <template v-slot:bottom>

      </template>

      <!-- Grandes dos modelos grid -->
      <template v-slot:item.grades="{ item }">
        <v-chip-group dense>
          <v-chip v-for="(grade, index) in item.grades" :key="index" x-small class="mr-1" color="info" label>
            Tam {{ grade.tamanho }} Qtd: {{ grade.quantidade }}
          </v-chip>
        </v-chip-group>
      </template>

      <template v-slot:item.totalPecas="{ item }">
        {{ calcularTotalPecasModelo(item) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="d-flex justify-start">
          <v-btn small color="primary" class="mr-2" @click="openModeloDialog(item, pedidoModelos.indexOf(item))">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn small color="error" @click="abrirConfirmacaoRemocao(pedidoModelos.indexOf(item))">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>


<!-- Card de Documentos -->
<v-card class="mb-6">

  <v-card-title class="bg-light-blue-lighten-1 white--text d-flex align-center">
    <v-icon color="white" class="mr-2" left>mdi-file-pdf-box</v-icon>
    Anexos
    <v-spacer></v-spacer>
    <v-btn color="white" variant="outlined" @click="adicionarDocumentoDialog = true">
      <v-icon left>mdi-plus</v-icon>
      Adicionar
    </v-btn>
  </v-card-title>
  <v-divider></v-divider>
  <v-card-text>

    <!-- preview do documento  -->
    <!-- <div v-if="pdfUrl" class="pdf-preview">
          <iframe :src="pdfUrl" width="100%" height="500px" frameborder="0"></iframe>
        </div> -->

    <v-row v-if="pedido.anexos && pedido.anexos.length > 0" dense class="pa-3">
      <v-col cols="12">
        <v-row v-for="(doc, index) in pedido.anexos" :key="index" align="center">
          <!-- Ícone do tipo de arquivo -->
          <v-col cols="1" class="d-flex justify-center">
            <v-icon v-if="doc.arquivo.type === 'application/pdf'" color="red">mdi-file-pdf-box</v-icon>
            <v-icon v-else color="blue">mdi-file-image</v-icon>
          </v-col>

          <!-- Descrição do documento -->
          <v-col cols="3">
            <span>{{ doc.descricao }}</span>
          </v-col>

          <!-- Nome do arquivo e tamanho -->
          <v-col cols="5">
            <span>{{ doc.arquivo.name }} ({{ formatFileSize(doc.arquivo.size) }})</span>
          </v-col>

          <!-- Botões de ação -->
          <v-col cols="3" class="d-flex justify-end">
            <v-btn small color="primary" @click="previewDocument(doc)">
              <v-icon>mdi-eye</v-icon>
            </v-btn>

            <v-btn small class="ml-2" color="error" @click="removeDocument(index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-card-text>
</v-card>

<!-- Adicionar Documento Dialog -->
<v-dialog v-model="adicionarDocumentoDialog" persistent max-width="500px">
  <v-card>
    <v-card-title class="bg-light-blue-lighten-1 white--text d-flex align-center">

      <v-icon left>mdi-file-pdf-box</v-icon>
      Adicionar Anexo
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>

      <v-file-input v-model="novoDocumento.arquivo" label="Selecione um arquivo PDF" accept="application/pdf" show-size
        variant="outlined" prepend-icon="mdi-file-pdf" @change="handleFileChange" ref="fileInput"></v-file-input>

      <v-text-field v-model="novoDocumento.descricao" label="Descrição do anexo"></v-text-field>

    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="adicionarDocumentoDialog = false">
        Cancelar
      </v-btn>
      <v-btn color="primary" @click="addDocument">
        Adicionar Anexo
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>



<!-- Preview Documentos -->
<v-dialog v-model="previewDialog.show" max-width="500px">
  <v-card>
    <v-card-title
  class="bg-light-blue-lighten-1 white--text d-flex justify-space-between align-center"
>
  <div class="d-flex align-center">
    <v-icon color="white" class="mr-2">mdi-file-pdf</v-icon>
    <span>Relatório Gerado</span>
  </div>

  <v-btn icon variant="text" @click="previewDialog.show = false">
    <v-icon color="white">mdi-close</v-icon>
  </v-btn>
</v-card-title>
<v-card-text class="text-center pa-6">
  <!-- Mensagem formatada em duas linhas -->
  <div class="mb-4">
    <div class="text-subtitle-1 font-weight-medium mb-1">Relatório gerado com sucesso</div>
    <div class="text-body-2 grey--text">
      "{{ previewDialog.documento?.descricao }}"
    </div>
  </div>

  <!-- Botão de abrir PDF -->
  <v-btn color="primary" @click="abrirPdfEmNovaAba" block>
    <v-icon left>mdi-open-in-new</v-icon>
    Abrir PDF em Nova Aba
  </v-btn>
</v-card-text>


  </v-card>
</v-dialog>



<!-- Dialog para visualizar PDF relatorio  -->

<!-- Dialog para Adicionar/Editar Modelo -->
<v-dialog v-model="modeloDialog.show" persistent max-width="800px">
  <v-card>
    <v-card-title class="bg-light-blue-lighten-1 white--text d-flex align-center">


      <v-icon color="white" class="mr-2">mdi-tshirt-crew</v-icon>
      {{ modeloDialog.isEdit ? 'Editar' : 'Adicionar' }} Modelo

    </v-card-title>


    <v-card-text class="pt-4">
      <v-row dense>
        <v-col cols="12" sm="6">
          <v-autocomplete v-model="modeloDialog.modelo.id_modelo" :items="modelosDisponiveisFiltrados" label="Modelo"
            item-title="descricao" item-value="id_modelo" :item-disabled="item => item.disabled" clearable
            variant="outlined" density="comfortable" @change="onModeloSelect"></v-autocomplete>
        </v-col>
        <v-col cols="12">
          <v-textarea v-model="modeloDialog.modelo.observacao" label="Observação" variant="outlined"
            density="comfortable" rows="2"></v-textarea>
        </v-col>
      </v-row>

      <!-- Card de Grades -->
      <v-card variant="outlined" class="mt-4">

        <v-card-title class="bg-light-blue-lighten-1 white--text d-flex align-center">


          <v-icon color="white" class="mr-2">mdi-tshirt-crew</v-icon>
          Grandes Do Modelo
          <v-spacer></v-spacer>
          <v-btn small color="white" variant="outlined" @click="openGradeDialog">
            <v-icon left small>mdi-pencil</v-icon>
            Adicionar Grade
          </v-btn>
        </v-card-title>

        <v-card-text>
          <!-- Lista de Grades em Formato de Linhas -->
          <v-row v-for="(grade, index) in modeloDialog.modelo.grades" :key="index" class="my-1" dense>
            <v-col cols="5">
              <v-select v-model="grade.tamanho" :items="tamanhosDisponiveis" item-title="text" item-value="tamanho"
                density="comfortable" clearable variant="outlined"></v-select>

            </v-col>
            <v-col cols="5">
              <v-text-field v-model.number="grade.quantidade" label="Quantidade" type="number" variant="outlined"
                min="1" density="comfortable"></v-text-field>
            </v-col>
            <v-col cols="2" class="d-flex align-center mb-5">
              <v-btn small color="error" @click="removeGradeTemp(index)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="cancelModelo">Cancelar Cadastro</v-btn>
      <v-btn color="success" @click="saveModelo">Salvar Modelo Atual</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Diálogo de Confirmação  Excluir Modelo -->
<v-dialog v-model="confirmDialog.show" persistent max-width="400px">
  <v-card>
    <v-card-title class="bg-light-blue-lighten-1 white--text d-flex align-center">


      <v-icon color="white" class="mr-2">mdi-alert</v-icon>
      Confirmar Exclusão
    </v-card-title>
    <v-card-text class="pt-4" style="white-space: pre-line">{{ confirmDialog.mensagem }}</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="confirmDialog.show = false">Cancelar</v-btn>
      <v-btn color="error" @click="confirmarRemocaoModelo">Excluir</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Dialog para Adicionar Grade -->
<v-dialog v-model="gradeDialog.show" max-width="500px">
  <v-card>

    <v-card-title class="bg-light-blue-lighten-1 white--text d-flex align-center">


      <v-icon color="white" class="mr-2">mdi-tshirt-crew</v-icon>
      Adicionar Grade
    </v-card-title>


    <v-card-text>
      <v-row>
        <v-col cols="12" sm="6">
          <v-select v-model="gradeDialog.grade.tamanho" :items="tamanhosDisponiveis" label="Tamanho" item-title="text"
            variant="outlined" item-value="tamanho" :item-disabled="item => item.disabled"
            density="comfortable"></v-select>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field v-model="gradeDialog.grade.quantidade" label="Quantidade" type="number" variant="outlined"
            min="1" density="comfortable"></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="cancelGrade">Cancelar</v-btn>
      <v-btn color="success" @click="saveGrade">Salvar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Diálogo de Saída -->
<v-dialog v-model="sairDialog.show" persistent max-width="400px">
  <v-card>
    <v-card-title style="background: linear-gradient(45deg, #ff9800, #ffa726);" class="white--text">
      <v-icon color="white" class="mr-2">mdi-alert</v-icon>
      Confirmar Saída
    </v-card-title>
    <v-card-text class="pt-4">
      Deseja realmente sair? Todas as alterações não salvas serão perdidas.
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="cancelarSaida">Cancelar</v-btn>
      <v-btn color="warning" @click="confirmarSaida">Sair</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


</v-container>





</template>

<script>

import { clienteService } from "@/services/clienteService";
import { sapeJodarcService } from "@/services/sapeJodarcService";
import { modeloService } from "@/services/modeloService";
import { gradeService } from "@/services/gradeService";
import { pedidoService } from "@/services/pedidoService";
import { toastInjectionKey, useToast } from "vue-toastification";

const toast = useToast();
// Adicione isso no início do seu componente, junto com outras constantes

const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://apps.tabosasistemas.com.br'  // Removido o /jodarc
  : 'http://localhost:8000';

export default {
  data() {
    return {
      diferenca: [],

      nomeRelatorioAtual: '',


      modeloSelecionado: null,

      fichaComposicaoDialog: {
        show: false,
        produto: null
      },

      fichaComposicaoDiferencaDialog: {
        show: false
      },


      fichaComposicaoDialogPedidoAtual: {
        show: false,
        produto: null
      },
      dadosPedidoSape: {
        pedido: null,
        produtos: []
      },
      idPedido: '',
      isEdit: false,
      mensagemDialog: 'Aguarde Carregando os dados!!',

      modelosDisponiveis: [],
      clientesDisponiveis: [],
      gradesDisponiveis: [],
      adicionarDocumentoDialog: false,
      pdfFile: null,
      pdfUrl: null,

      novoDocumento: {
        arquivo: null,  // Armazena o arquivo selecionado
        descricao: ''
      },


      confirmDialog: {
        show: false,
        index: null,
        mensagem: '',
      },

      pedido: {
        id_pedido: '',
        data_cadastro: new Date().toISOString().substr(0, 10),
        data_inicio: '',
        previsao_entrega: '',
        id_cliente: null,
        observacao: '',
        anexos: [], // Array para armazenar os anexos PDF
      },
      pedidoModelos: [],
      search: '',
      loadingDialog: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      headers: [
        { title: 'Modelo', value: 'descricao' },
        { title: 'Grades', value: 'grades' },
        { title: 'Qts Peças', value: 'totalPecas' },
        { title: 'Observação', value: 'observacao' },
        { title: 'Ações', value: 'actions', sortable: false }
      ],

      modeloDialog: {
        show: false,
        isEdit: false,
        editIndex: -1,
        modelo: {
          id_modelo: null,
          descricao: '',
          observacao: '',
          grades: []
        }
      },
      gradeDialog: {
        show: false,
        grade: {
          tamanho: '',
          quantidade: 1
        }
      },
      sairDialog: {
        show: false
      },
      novoDocumento: {
        arquivo: null,
        descricao: ''

      },
      previewDialog: {
        show: false,
        documento: null,
        url: ''
      },
      pdfDialog: {
        show: false,
        title: '',
        url: ''
      },
      leaveCallback: null,
    }
  },
  computed: {





    ordensProducaoModelo() {
      if (!this.modeloSelecionado) return [];

      const ordens = [];
      Object.entries(this.modeloSelecionado.tamanhos).forEach(([tamanho, dados]) => {
        if (dados.ordem_producao) {
          ordens.push({
            tamanho: tamanho,
            numero_op: dados.ordem_producao.numero,
            data_inicio: dados.ordem_producao.data_inicio,
            data_vencimento: dados.ordem_producao.data_vencimento,
            quantidade_planejada: dados.ordem_producao.quantidade_planejada,
            quantidade_fabricada: dados.ordem_producao.quantidade_fabricada
          });
        }
      });

      return ordens;
    },

    calcularTotalPecas() {
      return this.pedidoModelos.reduce((total, modelo) => {
        return total + this.calcularTotalPecasModelo(modelo);
      }, 0);
    },
    modelosDisponiveisFiltrados() {
      return this.modelosDisponiveis.map(modelo => ({
        ...modelo,
        disabled: this.pedidoModelos.some(m => m.id_modelo === modelo.id_modelo),
        descricao: this.pedidoModelos.some(m => m.id_modelo === modelo.id_modelo)
          ? `${modelo.descricao} (Já incluído)`
          : modelo.descricao
      }));
    },
    tamanhosDisponiveis() {
      // Lista de todos os tamanhos possíveis
      const todosTamanhos = this.gradesDisponiveis.map(grade => grade.descricao);

      // Linha alterada: Utiliza optional chaining e fallback para garantir que grades seja um array
      const gradesArray = this.modeloDialog.modelo?.grades ?? []; // linha alterada

      // Linha alterada: Utiliza o array garantido para criar o conjunto dos tamanhos já utilizados
      const tamanhosUtilizados = new Set(gradesArray.map(g => g.tamanho)); // linha alterada

      // Retorna array de objetos com tamanho e status disabled
      return todosTamanhos.map(tamanho => ({
        tamanho,
        disabled: tamanhosUtilizados.has(tamanho),
        text: tamanhosUtilizados.has(tamanho) ? `${tamanho} (Já incluído)` : tamanho
      }));
    },

  },
  async created() {

    this.idPedido = this.$route.params.id;

    console.log("ID extraído manualmente:", this.idPedido);

    // Defi a mensagem apenas se houver um ID
    if (this.idPedido) {
      this.mensagemDialog = `Aguarde, carregando os pedidos! ID: ${this.idPedido}`;
    }

    // Define modo edição
    this.isEdit = !!this.idPedido;

    // Se for edição, busca os dados necessários
    if (this.isEdit) {
      this.buscarPedidoPorId(this.idPedido);
    }

    // Buscar dados básicos necessários para qualquer caso (novo ou edição)
    // await this.buscarClientes();
    // await this.buscarModelos();
    // await this.buscarGrades();
  },

  async mounted() {
    toast.info("Aguarde, carregando os dados!");

    if (!this.isEdit) {
      this.loadingDialog = true;
      this.c = "Carregando clientes, modelos e grades...";
      await this.buscarClientes();
      // so se precisar      await this.buscarModelos();
      // so se precisar     await this.buscarGrades();
      this.loadingDialog = false;
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.temAlteracoesNaoSalvas()) {
      // Armazena a função next para usar após a confirmação
      this.leaveCallback = next;
      this.sairDialog.show = true;
    } else {
      next();
    }
  },

  methods: {

    abrirPdfEmNovaAba() {
  if (this.previewDialog.url) {
    const urlBase = this.previewDialog.url.split('?')[0];
    const urlComTimestamp = `${urlBase}?t=${Date.now()}`;

    // Garante que será uma nova aba limpa (evita reuso do Chrome)
    const novaAba = window.open('about:blank', '_blank'); // Garante nova aba real
    novaAba.location = urlComTimestamp; // Carrega o PDF com timestamp atualizado
  }
},

 
    gerarPdfFichaComposicaoEduardo() {
  this.mensagemDialog = 'Visualizando ';
  // Adiciona um timestamp à URL para evitar cache
  const urlComTimestamp = `${this.nomeRelatorioAtual}?t=${new Date().getTime()}`;
  this.previewDialog.url = urlComTimestamp;
  this.previewDialog.documento = {
    descricao: `Ficha de Composição`,
    url: urlComTimestamp
  };
  this.previewDialog.show = true;
},





    async chamarRelatorioAgrupadoPorModelo(produto) {
      this.loadingDialog = true;
      this.mensagemDialog = 'Gerando PDF da ficha de composição...';

      try {
        const response = await sapeJodarcService.sapeFichaAgrupadoPorModeloPdf({
          produto: produto.referencia,
          pedido_info: {
            id_pedido: this.pedido.id_pedido,
            cliente: this.pedido.id_cliente,
            produto_nome: produto.nome_produto,
            produto_quantidade: produto.quantidade
          },
          tipo: 'pedido_atual'
        });

        if (response.data.status === 'sucesso') {

          const baseUrl = this.getPdfBaseUrl();

          const fileUrl = `${baseUrl}/relatorioHtml/${response.data.arquivo}`;

          this.nomeRelatorioAtual = fileUrl;

          // Mostrar no diálogo existente
          this.previewDialog.url = fileUrl;
          this.previewDialog.documento = {
            descricao: `Ficha de Composição - ${produto.nome_produto}`,
            url: fileUrl
          };
          this.previewDialog.show = true;
        } else {
          toast.error(response.data.mensagem || 'Erro ao gerar PDF');
        }
      } catch (error) {
        console.error('Erro ao gerar PDF:', error);
        toast.error(error.response?.data?.mensagem || 'Erro ao gerar PDF');
      } finally {
        this.loadingDialog = false;
      }
    },


 


    calcularDiferenca(produto) {

      this.diferenca = produto.diferenca;
      this.fichaComposicaoDiferencaDialog.show = true;
    },


    getPdfBaseUrl() {
      // pra saber se estamos dentro do projeto, descomente o console.log
      // console.log(import.meta.env);  

      return import.meta.env.MODE === 'development'
        ? 'http://localhost:8000'
        : 'https://apps.tabosasistemas.com.br/jodarc';
    },


    async gerarPdfFichaComposicao(produto) {
      this.loadingDialog = true;
      this.mensagemDialog = 'Gerando PDF da ficha de composição...';

      try {
        const response = await sapeJodarcService.sapeRelatorioFichaComposicaoSimplesHtml({
          produto: produto.referencia,
          pedido_info: {
            id_pedido: this.pedido.id_pedido,
            docEntry: produto.ordem_producao.numero,
            cliente: this.pedido.id_cliente,
            produto_nome: produto.descricao_produto,
            produto_quantidade: produto.quantidade
          },
          tipo: 'pedido_atual'
        });

        if (response.data.status === 'sucesso') {

          const baseUrl = this.getPdfBaseUrl();

          const fileUrl = `${baseUrl}/relatorioHtml/${response.data.arquivo}?t=${new Date().getTime()}`;
          this.nomeRelatorioAtual = fileUrl;

          // Mostrar no diálogo existente
          this.previewDialog.url = fileUrl;
          this.previewDialog.documento = {
            descricao: `Ficha de Composição - ${produto.descricao_produto}`,
            url: fileUrl
          };
          this.previewDialog.show = true;
        } else {
          toast.error(response.data.mensagem || 'Erro ao gerar PDF');
        }
      } catch (error) {
        console.error('Erro ao gerar PDF:', error);
        toast.error(error.response?.data?.mensagem || 'Erro ao gerar PDF');
      } finally {
        this.loadingDialog = false;
      }
    }

    ,

    selecionarModelo(modelo) {
      this.modeloSelecionado = modelo;
    }
    ,
    mostrarFichaComposicao(produto) {
      this.fichaComposicaoDialog.show = true;
      this.fichaComposicaoDialog.produto = produto;
    },
    mostrarFichaComposicaoPedidoAtual(produto) {
      this.fichaComposicaoDialogPedidoAtual.show = true;
      this.fichaComposicaoDialogPedidoAtual.produto = produto;
    },
    somarQuantidadePai(id_pai) {
      return this.dadosPedidoSape.produtos.filter(produto => produto.id_pai === id_pai).reduce((sum, produto) => sum + produto.quantidade, 0);
    },

    importarModelosSape() {
      if (!this.dadosPedidoSape || !this.dadosPedidoSape.produtos) {
        toast?.error('Não há dados do pedido SAP para importar');
        return;
      }

      try {
        // Agrupa produtos por id_pai
        const modelosAgrupados = this.dadosPedidoSape.produtos.reduce((acc, produto) => {
          const id_pai = String(produto.id_pai || '');

          if (!acc[id_pai]) {
            acc[id_pai] = {
              id_pai: id_pai,
              nome_produto: produto.descricao_produto.split(' - ')[0],
              tamanhos: {}
            };
          }

          // Se já existe uma grade, soma a quantidade
          if (acc[id_pai].tamanhos[produto.grade]) {
            acc[id_pai].tamanhos[produto.grade].quantidade += parseInt(produto.quantidade);
          } else {
            acc[id_pai].tamanhos[produto.grade] = {
              quantidade: parseInt(produto.quantidade),
              ordem_producao: produto.ordem_producao
            };
          }

          return acc;
        }, {});

        // Para cada modelo agrupado, cria um novo modelo
        Object.values(modelosAgrupados).forEach((modelo) => {
          const modeloCadastrado = this.modelosDisponiveis.find(m => m.id_sap === modelo.id_pai);

          if (!modeloCadastrado) {
            console.log(`Modelo ${modelo.id_pai} não encontrado nos modelos cadastrados`);
            return;
          }

          // Prepara o objeto do modelo
          this.modeloDialog.modelo = {
            id_modelo: modeloCadastrado.id_modelo,
            descricao: modeloCadastrado.descricao,
            observacao: '',
            grades: []
          };

          // Adiciona cada grade usando a estrutura correta
          Object.entries(modelo.tamanhos).forEach(([grade, info]) => {
            const novaGrade = {
              tamanho: grade, // Mudado de grade para tamanho
              quantidade: info.quantidade
            };
            this.modeloDialog.modelo.grades.push(novaGrade);
          });

          console.log('Modelo final:', this.modeloDialog.modelo);
          console.log('Grades final:', this.modeloDialog.modelo.grades);

          // Verifica se há grades duplicadas
          const grades = this.modeloDialog.modelo.grades;
          const gradesUnicas = new Set(grades.map(g => g.tamanho));
          if (gradesUnicas.size !== grades.length) {
            console.error(`Modelo ${modelo.id_pai} tem grades duplicadas`);
            return;
          }

          // Salva o modelo completo
          this.saveModelo();
        });

        toast?.success('Modelos e grades importados com sucesso!');
      } catch (error) {
        console.error('Erro ao importar modelos:', error);
        toast?.error('Erro ao importar modelos do SAP');
      }
    },


    agruparProdutosPorModelo() {
      if (!this.dadosPedidoSape?.produtos) return [];

      // Agrupa produtos por id_pai
      const modelosAgrupados = this.dadosPedidoSape.produtos.reduce((acc, produto) => {
        const id_pai = produto.id_pai;
        const grade = produto.grade;

        if (!acc[id_pai]) {
          acc[id_pai] = {
            id_pai: id_pai,
            nome_produto: produto.descricao_produto.split(' - ')[0],
            referencia: produto.referencia, // ✅ Adicionado aqui

            tamanhos: {},
            ordens_producao: [] // Inicializa o array de ordens de produção
          };
        }

        // Adiciona informações do tamanho
        if (!acc[id_pai].tamanhos[grade]) {
          acc[id_pai].tamanhos[grade] = {
            quantidade: 0
          };
        }
        acc[id_pai].tamanhos[grade].quantidade += parseInt(produto.quantidade) || 0;

        // Adiciona ordem de produção se não existir ainda
        if (produto.ordem_producao) {
          const ordemExistente = acc[id_pai].ordens_producao?.find(
            op => op.numero === produto.ordem_producao.numero && op.grade === grade
          );

          if (!ordemExistente) {
            acc[id_pai].ordens_producao.push({
              numero: produto.ordem_producao.numero,
              grade: grade,
              quantidade: parseInt(produto.quantidade) || 0
            });
          }
        }

        return acc;
      }, {});

      // Converte o objeto em array
      return Object.values(modelosAgrupados);
    },

    getClienteSapePorId(id_sap) {
      const cliente = this.clientesDisponiveis.find(cliente => cliente.id_sap === id_sap);
      return cliente ? cliente.id : null;
    },

    // mozar
    async getPedidoSapePorId(id, idL) {
      try {

        this.mensagemDialog = 'Carregando dados do pedido...';
        this.loadingDialog = true;

        const response = await sapeJodarcService.sapePedido({ id, idL }); // Passando id e idL no objeto
        this.dadosPedidoSape = response.data;
        if (this.dadosPedidoSape) {
          const formatarData23 = (data) => {
            if (typeof data === 'object' && data.date) {
              return data.date.substring(0, 10);
            } else if (typeof data === 'string') {
              return data.includes("T") ? data.split("T")[0] : data.substring(0, 10);
            }
            return '';
          };
          this.pedido.id_cliente = this.getClienteSapePorId(this.dadosPedidoSape.pedido.id_cliente) || this.dadosPedidoSape.pedido.id_cliente;
          this.pedido.data_cadastro = formatarData23(this.dadosPedidoSape.pedido.pedido_cadastro);
          this.pedido.previsao_entrega = formatarData23(this.dadosPedidoSape.pedido.pedido_previsao);
        }
        this.mensagemDialog = 'Aguarde !! Carregados os dados';
        this.loadingDialog = false;
      } catch (error) {
        this.loadingDialog = false;
        console.error(error);

        toast.error("Erro ao buscar o pedido");
        return null;
      }
    },


    async submitForm() {
      try {
        this.mensagemDialog = `Salvando Pedido No ${this.pedido.id_pedido || "Novo"}...`;
        this.loadingDialog = true;

        // 🔹 Função para formatar datas corretamente para envio
        const formatarDataParaEnvio = (data) => (data ? data : null);

        // 🔹 Garantindo que `pedidoModelos` existe antes de acessar
        const modelos = Array.isArray(this.pedidoModelos) ? this.pedidoModelos : [];

        // 🔹 Preparando os dados do pedido para envio
        const pedidoData = {
          id_pedido: this.pedido.id_pedido || null,
          id_cliente: this.pedido.id_cliente,

          data_cadastro: formatarDataParaEnvio(this.pedido.data_cadastro),
          data_inicio: formatarDataParaEnvio(this.pedido.data_inicio),
          previsao_entrega: formatarDataParaEnvio(this.pedido.previsao_entrega),

          // pedro antes da reunisaqo

          pedido_status: this.pedido.pedido_status || "Pendente",
          observacao: this.pedido.observacao || "",
          cliente: this.pedido.cliente || {}, // Garante que o objeto cliente existe
          anexos: this.pedido.anexos || [], // Garante que os anexos existem
        };

        // 🔹 Verifica se há modelos no pedido
        if (Array.isArray(pedido.pedido_modelos) && pedido.pedido_modelos.length > 0) {
          this.pedido.modelos = pedido.pedido_modelos.map((modelo) => {
            // 🔹 Tenta encontrar o modelo na lista carregada previamente
            const modeloEncontrado = this.listaModelos.find((m) => m.id === modelo.id_modelo);

            return {
              id_pedido_modelo_seq: modelo.id_pedido_modelo_seq,
              id_pedido: modelo.id_pedido,
              id_modelo: modelo.id_modelo,
              descricao: modeloEncontrado ? modeloEncontrado.descricao : "Modelo não encontrado", // 🔹 Busca a descrição do modelo
              observacao: modelo.observacao || "",
              grades: Array.isArray(modelo.pedido_modelo_grades) ? modelo.pedido_modelo_grades : [],
            };
          });
        }

        console.log("🚀 Dados enviados para API:", JSON.stringify(pedidoData, null, 2));

        // 🔹 Criando `FormData` para envio
        const formData = new FormData();
        formData.append("pedido", JSON.stringify(pedidoData));

        // 🔹 Adicionando anexos corretamente
        if (Array.isArray(this.pedido.anexos) && this.pedido.anexos.length > 0) {
          this.pedido.anexos.forEach((doc, index) => {
            if (doc.arquivo) {
              formData.append(`anexos[${index}]`, doc.arquivo);
              formData.append(`descricao_${index}`, doc.descricao || "");
            }
          });
        }

        // 🔹 Definindo se é edição ou criação de pedido
        let response;
        if (this.isEdit) {
          response = await pedidoService.AtualizarPedido(this.pedido.id_pedido, formData);
        } else {
          response = await pedidoService.IncluirPedido(formData);
        }

        toast.success("✅ Pedido salvo com sucesso!");

      } catch (error) {
        console.error("❌ Erro ao salvar o pedido:", error);

        // 🔹 Tratamento de erro na API
        if (error.response && error.response.data) {
          toast.error(error.response.data.message || "Erro ao salvar o pedido");
        } else {
          toast.error("Erro ao salvar o pedido: " + error.message);
        }
      } finally {
        this.loadingDialog = false;
      }
    },


    async buscarPedidoPorId(id) {
      try {
        this.loadingDialog = true;
        const pedido = await pedidoService.obterPedidoPorId(id);

        if (!pedido) {
          console.error("❌ Pedido não encontrado!");
          return;
        }


        // 🔹 Função para formatar datas corretamente
        const formatarData2 = (data) => (data ? data.split("T")[0] : "");

        // 🔹 Preenche os dados do pedido 
        this.pedido = {
          id_pedido: pedido.id_pedido,
          id_cliente: pedido.id_cliente,

          data_cadastro: formatarData2(pedido.data_cadastro),
          data_inicio: formatarData2(pedido.data_inicio),
          previsao_entrega: formatarData2(pedido.data_previsao || ""), // Evita null no campo de input
          pedido_status: pedido.pedido_status || "Pendente",
          observacao: pedido.observacao || "",
          cliente: pedido.cliente || {}, // Garante que o objeto cliente existe
          anexos: pedido.anexos || [], // Garante que os anexos existem
        };

        // 🔹 Mapeia os modelos e grades corretamente
        this.pedidoModelos = pedido.pedido_modelos.map((modelo) => ({
          id_pedido_modelo_seq: modelo.id_pedido_modelo_seq,
          id_modelo: modelo.id_modelo,
          descricao: modelo.modelo.descricao,
          observacao: modelo.observacao || "",
          modelo: modelo.modelo || {}, // Modelo detalhado
          grades: modelo.pedido_modelo_grades.map((grade) => ({
            id_pedido_modelo_grade_seq: grade.id_pedido_modelo_grade_seq,
            tamanho: grade.tamanho,
            quantidade: grade.quantidade,
          })),
        }));

        console.log("✅ Pedido carregado:", this.pedido);
      } catch (error) {
        console.error("❌ Erro ao buscar pedido:", error);
        toast.error("Erro ao carregar o pedido.");
      } finally {
        this.loadingDialog = false;
      }
    }


    ,

    async buscarGrades() {
      try {
        const grades = await gradeService.obterTodos();

        this.gradesDisponiveis = grades.map(grade => ({
          id_grade: grade.id,
          descricao: grade.tamanho,
        }));
      } catch (error) {
        console.error(error);

      }
    },
    async buscarModelos() {
      try {
        const modelos = await modeloService.obterTodos();
        // console.log('Modelos retornados da API:', modelos);

        this.modelosDisponiveis = modelos.map(modelo => ({
          id_modelo: modelo.id,
          id_sap: String(modelo.id_interno || ''), // Converte para string
          descricao: modelo.descricao
        }));

        // console.log('modelosDisponiveis final:', this.modelosDisponiveis);
      } catch (error) {
        console.error('Erro ao buscar modelos:', error);
        toast?.error('Erro ao buscar modelos');
      }
    },
    async buscarClientes() {
      try {
        const clientes = await clienteService.obterTodos();

        this.clientesDisponiveis = clientes;
      } catch (error) {
        console.error(error);

      }
    },

    handleFileChange(event) {
      try {
        // Determine the file from different possible input types
        const file = event instanceof File
          ? event
          : (event?.target?.files?.[0] || null);

        console.log('File received:', file); // Debug log

        if (!file) {
          this.novoDocumento.arquivo = null;
          this.pdfUrl = null;
          toast?.error('Nenhum arquivo foi selecionado.');
          return;
        }

        // Verifica se o arquivo é realmente um PDF
        if (!(file.type === 'application/pdf' || file.name.endsWith('.pdf'))) {
          this.novoDocumento.arquivo = null;
          this.pdfUrl = null;
          toast?.error('O arquivo selecionado não é um PDF válido.');
          return;
        }

        // Armazena o arquivo corretamente
        this.novoDocumento.arquivo = file;

        // Atualiza a descrição com o nome do arquivo
        this.novoDocumento.descricao = file.name;

        // Gera preview do PDF
        this.previewPDF(file);
      } catch (error) {
        console.error('Erro ao processar arquivo:', error);
        toast?.error('Erro ao processar o arquivo');
        this.novoDocumento.arquivo = null;
        this.pdfUrl = null;
      }
    },

    previewPDF(file) {
      if (!file) {
        this.pdfUrl = null;
        return;
      }

      // Criar URL para exibição no iframe
      this.pdfUrl = URL.createObjectURL(file);
    },

    confirmarRemocaoModelo() {
      if (this.confirmDialog.index !== null) {
        this.pedidoModelos.splice(this.confirmDialog.index, 1);
      }
      this.confirmDialog.show = false;
      this.confirmDialog.index = null;
      this.confirmDialog.mensagem = '';
    },

    abrirConfirmacaoRemocao(index) {
      const modelo = this.pedidoModelos[index];
      if (!modelo) return;

      const totalPecas = this.calcularTotalPecasModelo(modelo);

      this.confirmDialog.mensagem = `Deseja realmente excluir este modelo?\n\n` +
        `Modelo: ${modelo.descricao}\n` +
        `Total de Grades: ${modelo.grades.length}\n` +
        `Total de Peças: ${totalPecas}\n\n` +
        `Esta ação não poderá ser desfeita.`;

      this.confirmDialog.index = index;
      this.confirmDialog.show = true;
    },

    resetModeloDialog() {
      this.modeloDialog = {
        show: false,
        isEdit: false,
        editIndex: -1,
        modelo: {
          id_modelo: null,
          descricao: '',
          observacao: '',
          grades: []
        }
      };
    },

    onModeloSelect(modeloId) {
      const modeloSelecionado = this.modelosDisponiveis.find(m => m.id_modelo === modeloId);
      if (modeloSelecionado) {
        this.modeloDialog.modelo.descricao = modeloSelecionado.descricao;
      } else {
        this.modeloDialog.modelo.descricao = '';
      }
    },
    openModeloDialog(modelo = null, index = -1) {
      this.modeloDialog.isEdit = !!modelo; // mantém a flag de edição
      this.modeloDialog.editIndex = index;   // guarda o índice do modelo sendo editado

      if (modelo) {
        // CRIADO: Realiza uma cópia profunda para preservar o estado original
        this.modeloDialog.modelo = JSON.parse(JSON.stringify(modelo)); // linha alterada para cópia profunda
      } else {
        this.modeloDialog.modelo = {
          id_modelo: null,
          descricao: '',
          observacao: '',
          grades: []
        }
      }
      this.modeloDialog.show = true; // abre o diálogo
    },

    saveModelo() {
      if (!this.modeloDialog.modelo.id_modelo) {
        alert('Selecione um modelo');
        return;
      }

      // Verifica se o modelo já existe no pedido (exceto quando estiver editando)
      const modeloExistente = this.pedidoModelos.find(
        (m, index) => m.id_modelo === this.modeloDialog.modelo.id_modelo &&
          index !== this.modeloDialog.editIndex
      );

      if (modeloExistente) {
        alert('Este modelo já foi adicionado ao pedido');
        return;
      }

      // Verifica grades duplicadas
      const grades = this.modeloDialog.modelo.grades;
      const gradesUnicas = new Set(grades.map(g => g.tamanho));
      if (gradesUnicas.size !== grades.length) {
        alert('Não é permitido repetir o mesmo tamanho de grade para um modelo');
        return;
      }

      // Verifica se existe alguma grade sem tamanho ou quantidade
      const gradeInvalida = grades.find(grade => !grade.tamanho || !grade.quantidade);
      if (gradeInvalida) {
        alert('Todas as grades devem ter tamanho e quantidade preenchidos');
        return;
      }

      const modeloSelecionado = this.modelosDisponiveis.find(
        m => m.id_modelo === this.modeloDialog.modelo.id_modelo
      );

      const novoModelo = {
        id_modelo: this.modeloDialog.modelo.id_modelo,
        descricao: modeloSelecionado?.descricao || '',
        observacao: this.modeloDialog.modelo.observacao,
        grades: [...this.modeloDialog.modelo.grades]
      };

      if (this.modeloDialog.editIndex > -1) {
        this.pedidoModelos.splice(this.modeloDialog.editIndex, 1, novoModelo);
      } else {
        this.pedidoModelos.push(novoModelo);
      }

      this.modeloDialog.show = false;
      this.resetModeloDialog();
    },
    calcularTotalPecasModelo(modelo) {
      if (!modelo || !Array.isArray(modelo.grades)) {
        return 0; // Retorna 0 se grades não existir ou não for um array
      }

      return modelo.grades.reduce((total, grade) => {
        return total + (parseInt(grade.quantidade) || 0);
      }, 0);
    },
    removeGradeTemp(index) {
      this.modeloDialog.modelo.grades.splice(index, 1);
    },
    openGradeDialog() {
      this.gradeDialog.show = true;
    },
    cancelGrade() {
      this.gradeDialog.show = false;
      this.gradeDialog.grade = {
        tamanho: '',
        quantidade: 1
      };
    },
    saveGrade() {
      if (!this.gradeDialog.grade.tamanho || this.gradeDialog.grade.quantidade <= 0) {
        alert('Preencha o tamanho e a quantidade');
        return;
      }

      const novaGrade = {
        tamanho: this.gradeDialog.grade.tamanho,
        quantidade: parseInt(this.gradeDialog.grade.quantidade) || 0
      };

      // LINHA ADICIONADA: Garante que o objeto modelo existe
      if (!this.modeloDialog.modelo) {
        this.modeloDialog.modelo = { grades: [] };
      }
      // LINHA ADICIONADA: Garante que a propriedade grades está definida como um array
      if (!this.modeloDialog.modelo.grades) {
        this.modeloDialog.modelo.grades = [];
      }

      // Procura se já existe uma grade com o mesmo tamanho
      const gradeExistente = this.modeloDialog.modelo.grades.findIndex(
        g => g.tamanho === novaGrade.tamanho
      );

      if (gradeExistente >= 0) {
        // Se existir, atualiza a quantidade
        this.modeloDialog.modelo.grades[gradeExistente].quantidade += novaGrade.quantidade;
      } else {
        // Se não existir, adiciona nova grade
        this.modeloDialog.modelo.grades.push(novaGrade);
      }

      // Limpa o formulário do diálogo de grade
      this.gradeDialog.show = false;
      this.gradeDialog.grade = {
        tamanho: '',
        quantidade: 1
      };
    }
    ,
    cancelModelo() {
      // Ao cancelar, simplesmente fecha o diálogo e reseta o objeto do diálogo,
      // garantindo que o objeto original no array "pedidoModelos" não seja modificado.
      this.modeloDialog.show = false;
      this.modeloDialog.isEdit = false;
      this.modeloDialog.editIndex = -1;
      this.modeloDialog.modelo = {
        id_modelo: null,
        descricao: '',
        observacao: '',
        grades: []
      };
    },

    voltarMenu() {
      this.$router.push({ name: "ConsultaPedidosMobile" }).catch(() => { });
    },

    removeModelo(index) {
      const modelo = this.pedidoModelos[index];
      if (!modelo) return;

      // Calcula o total de peças do modelo
      const totalPecas = this.calcularTotalPecasModelo(modelo);

      // Monta a mensagem de confirmação
      const mensagem = `Deseja realmente excluir este modelo?\n\n` +
        `Modelo: ${modelo.descricao}\n` +
        `Total de Grades: ${modelo.grades.length}\n` +
        `Total de Peças: ${totalPecas}\n\n` +
        `Esta ação não poderá ser desfeita.`;

      // Confirma com o usuário
      if (confirm(mensagem)) {
        this.pedidoModelos.splice(index, 1);
      }
    },

    confirmarSaida() {
      if (this.leaveCallback) {
        this.leaveCallback();
        this.leaveCallback = null;
      }
      else {
        this.$router.push({ name: "ConsultaPedidosMobile" }).catch(() => { });
      }
      this.sairDialog.show = false;
    },

    cancelarSaida() {
      if (this.leaveCallback) {
        this.leaveCallback(false);
        this.leaveCallback = null;
      }
      this.sairDialog.show = false;
    },

    temAlteracoesNaoSalvas() {
      // Retorna true se houver alterações não salvas (exemplo simples)
      return this.pedido.id_pedido !== '' || this.pedido.anexos.length > 0 || this.pedidoModelos.length > 0;
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    addDocument() {
      if (!this.novoDocumento.arquivo || !this.novoDocumento.descricao) {
        toast?.error('Selecione um arquivo e preencha a descrição.');
        return;
      }

      const tiposPermitidos = ['application/pdf'];
      if (!tiposPermitidos.includes(this.novoDocumento.arquivo.type)) {
        toast?.error('Apenas arquivos PDF são permitidos.');
        return;
      }

      // Adiciona o documento ao pedido
      this.pedido.anexos.push({
        arquivo: this.novoDocumento.arquivo,
        descricao: this.novoDocumento.descricao
      });

      // Reseta os campos após adicionar o documento
      this.novoDocumento.arquivo = null;
      this.novoDocumento.descricao = '';

      // Reseta o v-file-input para que possa selecionar um novo arquivo
      this.$nextTick(() => {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.reset();
        }
      });

      toast?.success('Anexo adicionado com sucesso!');
    },

    previewDocument(doc) {
      if (!doc || !doc.arquivo) {
        toast?.error('Nenhum documento disponível para visualizar.');
        return;
      }

      // Cria uma URL para exibição do PDF
      this.previewDialog.url = URL.createObjectURL(doc.arquivo);
      this.previewDialog.documento = doc;
      this.previewDialog.show = true;
    },

    removeDocument(index) {
      this.pedido.anexos.splice(index, 1);
    },

    async buscarPedidoPorId(id) {
      try {
        this.loadingDialog = true;
        const pedido = await pedidoService.obterPedidoPorId(id);

        if (!pedido) {
          console.error("Pedido não encontrado!");
          return;
        }

        alert('jose');


        // Preenche os dados do pedido
        this.pedido = {
          id_pedido: pedido.id_pedido,
          id_cliente: pedido.id_cliente,
          data_cadastro: pedido.data_cadastro,
          data_inicio: pedido.data_inicio,
          previsao_entrega: pedido.data_previsao || "", // Evita null no campo de input
          pedido_status: pedido.pedido_status || "Pendente",
          observacao: pedido.observacao || "",
          cliente: pedido.cliente || {}, // Garante que o objeto cliente existe
          anexos: pedido.anexos || [], // Garante que os anexos existem
        };

        // Mapeia os modelos e grades corretamente
        this.pedidoModelos = pedido.pedido_modelos.map((modelo) => ({
          id_pedido_modelo_seq: modelo.id_pedido_modelo_seq,
          id_modelo: modelo.id_modelo,
          descricao: modelo.modelo.descricao,
          observacao: modelo.observacao || "",
          modelo: modelo.modelo || {}, // Modelo detalhado
          grades: modelo.pedido_modelo_grades.map((grade) => ({
            id_pedido_modelo_grade_seq: grade.id_pedido_modelo_grade_seq,
            tamanho: grade.tamanho,
            quantidade: grade.quantidade,
          })),
        }));

        console.log("Pedido carregado:", this.pedido);
      } catch (error) {
        console.error("Erro ao buscar pedido:", error);
        toast.error("Erro ao carregar o pedido.");
      } finally {
        this.loadingDialog = false;
      }
    },




  }
}
</script>

<style scoped>
.v-data-table :deep(.v-data-table__wrapper) {
  overflow-x: auto;
}

.v-simple-table {
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.v-simple-table th {
  background-color: #f5f5f5;
  font-weight: bold;
}

.v-simple-table td,
.v-simple-table th {
  padding: 8px 16px !important;
}

.buttons-container {
  padding: 16px;
  margin-top: 16px;
  background-color: white;
}

@media (min-height: 600px) {
  .buttons-container {
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}

.table-header {
  background-color: #3f51b5;
  /* Blue header */
  color: white;
  font-weight: bold;
}

th {
  padding: 10px;
}

.bg-grey-lighten-4 {
  background-color: #f5f5f5;
}

.bg-blue-lighten-5 {
  background-color: #e3f2fd;
}

v-table th,
v-table td {
  text-align: center;
  padding: 8px;
}
</style>
